import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=6226af16&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=6226af16&prod&lang=scss&scoped=true&"
import style1 from "./Show.vue?vue&type=style&index=1&id=6226af16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226af16",
  null
  
)

export default component.exports